import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { IncidentNoteModel } from '@models';

@Component({
  imports: [CommonModule],
  selector: 'avs-incident-note',
  styleUrl: './incident-note.component.scss',
  templateUrl: './incident-note.component.html',
})
export class IncidentNoteComponent {
  note = input.required<IncidentNoteModel>();
}
